/* eslint-disable react-hooks/exhaustive-deps */

import {
  Grid,
} from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import { updateDestinationEstimatedDates, getDestinationEstimatedDates } from 'modules/authorizations/store/actions/destinationService.actions';
import { GET_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE, UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE } from 'modules/authorizations/store/types/destinationServiceTypes';
import { withDateChronology } from 'utilities/dateChronology';

const ESTIMATED_DATE_PAIRS = [
  ['familyTravelEstimatedStartDate', 'familyTravelEstimatedEndDate'],
  ['familyTravelActualStartDate', 'familyTravelActualEndDate'],
  ['finalMoveEstimatedStartDate', 'finalMoveEstimatedEndDate'],
  ['finalMoveActualStartDate', 'finalMoveActualEndDate'],
];

const EstimatedDatesCard = (props) => {

  const [isLoading, setIsLoading] = useState(false);

  const { estimatedDates, hideEdit, authId, enforceDateChronology = false } = props;

  const estimatedDatesTabs = [
    { header: 'Estimated Dates', order: 1, iconPath: ['fas', 'fa-calendar-alt'] },
  ];
    
  const estimatedDatesSummaries = [
    { header: 'Family Travel Estimated Start', accessorKey: 'familyTravelEstimatedStartDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.familyTravelEstimatedStartDate : null, tab: 1 },
    { header: 'Family Travel Estimated End', accessorKey: 'familyTravelEstimatedEndDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.familyTravelEstimatedEndDate : null, tab: 1 },
    { header: 'Family Travel Actual Start', accessorKey: 'familyTravelActualStartDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.familyTravelActualStartDate : null, tab: 1 },
    { header: 'Family Travel Actual End', accessorKey: 'familyTravelActualEndDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.familyTravelActualEndDate : null, tab: 1 },
    { header: 'Final Move Estimated Start', accessorKey: 'finalMoveEstimatedStartDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.finalMoveEstimatedStartDate : null, tab: 1 },
    { header: 'Final Move Estimated End', accessorKey: 'finalMoveEstimatedEndDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.finalMoveEstimatedEndDate : null, tab: 1 },
    { header: 'Final Move Actual Start', accessorKey: 'finalMoveActualStartDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.finalMoveActualStartDate : null, tab: 1 },
    { header: 'Final Move Actual End', accessorKey: 'finalMoveActualEndDate', type: 'date', required: false, value: estimatedDates ? estimatedDates.finalMoveActualEndDate : null, tab: 1 },
  ];
  
  const updateEstimatedDatesFields = async (tab, values) => {
    setIsLoading(true);
    let newVals = { ...estimatedDates };
    newVals.authorizationFileId = authId;
    // A cleared date input holds '', which the API can't read as a date.
    newVals.familyTravelActualEndDate = values.familyTravelActualEndDate || null;
    newVals.familyTravelActualStartDate = values.familyTravelActualStartDate || null;
    newVals.familyTravelEstimatedEndDate = values.familyTravelEstimatedEndDate || null;
    newVals.familyTravelEstimatedStartDate = values.familyTravelEstimatedStartDate || null;
    newVals.finalMoveActualEndDate = values.finalMoveActualEndDate || null;
    newVals.finalMoveActualStartDate = values.finalMoveActualStartDate || null;
    newVals.finalMoveEstimatedEndDate = values.finalMoveEstimatedEndDate || null;
    newVals.finalMoveEstimatedStartDate = values.finalMoveEstimatedStartDate || null;
    
      const resp = await props.updateDestinationEstimatedDates(authId, newVals);
      if (resp.type === UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE) {
        props.showToast('Failed to update the estimated dates info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else { 
        const getResp = await props.getDestinationEstimatedDates(authId);
        if (getResp.type === GET_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE) {
          return false;
        } else {
          setIsLoading(false);
          return true; 
        }
    }
  };
  
  return (
    <Grid item sx={{ marginBottom: '10px' }}>
      <EditableCard
        tabs={estimatedDatesTabs}
        summaries={enforceDateChronology ? withDateChronology(estimatedDatesSummaries, ESTIMATED_DATE_PAIRS) : estimatedDatesSummaries}
        numColumns={2} 
        updateFields={updateEstimatedDatesFields}
        isLoading={isLoading}
        hideEdit={hideEdit}
      />
    </Grid>
  );
  
};
  
const mapStateToProps = (state) => {
  return {
  };
};
  
export default compose(
  connect(mapStateToProps, {
    getDestinationEstimatedDates,
    updateDestinationEstimatedDates,
    showToast,
  }),
)(EstimatedDatesCard);